import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';
import '@aws-amplify/ui-react/styles.css';
import { useState, useEffect } from 'react';
import SEOComponent from '../components/SEOComponent';
import SiteCard from '../components/SiteCard';
import { Container } from 'react-bootstrap';

function OpenAPIInfo() {
  const [system, setSystem] = useState(null);

  useEffect(() => {
    if (system) {
      try {
        const currentSpec = system.specSelectors.specJson().toJS();
        system.specActions.updateJsonSpec({
          ...currentSpec,
          servers: [
            {
              url: process.env.REACT_APP_API_URL
            }
          ]
        });
      } catch (error) {
      }
    }
  }, [system]);

  const onComplete = (swaggerSystem) => {
    setSystem(swaggerSystem);
  };

  return (
    <div>
        <SEOComponent
    title={'ottaproperty.co.uk API Documentation'}
    description={'API Documentation for ottaproperty.co.uk'}
  />
    <Container style={{ marginBottom: "2rem", fontSize: ".8rem" }}>
          <SiteCard header="API Documentation"  content= {

      <SwaggerUI 
        url={'/openapi.yaml'}
        onComplete={onComplete}
      />
      } />
    </Container>
    </div>
  );
}

export default OpenAPIInfo;